module.exports = __webpack_public_path__ + "img/01.539dc147.png";